module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAA7UlEQVR4Ae3XHVBEYRSA4Ys55xMEYe4ehPmEuUMY5pNPGOSUT7i4sLD4ru83a/fu7M/z8JFzXjoTAAAAAAAAAFyr6rZ6qj6qv2lZVHfVS/VZ/bdnYl7VQ/VafVWrBrMFoLqpHqu36rtaN1gkANVPtW0kwDF0mAACCCCAAAJsql8BFnLg2O/Vc3U/zM0bgPHYo8sPcAYLCyDASAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEECATpwAAggggAACCCCAAAII4BG7gAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggAAAAAAAAAAACwAyNXoxCjB6sAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plus-one-icon.png
// module id = 330
// module chunks = 0